module.exports = __webpack_public_path__ + "static/media/war-shout.d9bac554.png";